import { ManagerTableCellLabel } from '../ManagerTableCellLabel';
import { TABLE_LABELS } from '@/constants/labels';

interface RenderProps {
  mostRecentActivity: string | null;
}

/**
 * Activity status cell for the manager dashboard table. This component is responsible for
 * displaying the date of the most recent activity for a user.
 */
export const ManagerTableCellActivityStatus: React.FC<RenderProps> = ({ mostRecentActivity }) => {
  const text = mostRecentActivity !== null ? mostRecentActivity : TABLE_LABELS.NO_ACTIVITY;
  return <ManagerTableCellLabel label={text} />;
};

ManagerTableCellActivityStatus.displayName = 'ManagerTableCellActivityStatus';

export default ManagerTableCellActivityStatus;
